<template>
  <div>
    <b-row class="py-3">
      <ProductImages :product="product" />
      <ProductDetails v-if="product.id" :product="product" />
    </b-row>
  </div>
</template>

<script>
import ProductImages from "../components/product-page-components/ProductImages";
import ProductDetails from "../components/product-page-components/ProductDetails";

// import VueSlickCarousel from "vue-slick-carousel";
// import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  name: "ProductPage",
  components: {
    ProductImages,
    ProductDetails,
  },
  data() {
    return {
      product: [],
    };
  },

  mounted() {
    this.$axios.get(`products/${this.$route.params.id}`).then((res) => {
      this.product = res.data.data;
    });
  },
};
</script>

<style scoped>
.center-title {
  font-weight: 600;
  font-size: 2rem;
}

.test {
  height: 100px;
  width: 50px;
  margin: 10px;
  border: 1px solid blue;
}
</style>
